import React, { useRef, useEffect } from 'react';
import { DataTablesProps } from './DataTables.props';

import { DataGrid } from '@mui/x-data-grid';
import './DataTables.css';

export const DataTables: React.FC<DataTablesProps> = (props) => {
  const {
    tblRows,
    tblColumns,
    loadingTable,
    pageSize,
    onChangePageSize,
    rowPerPages,
    customPaging,
    defaultSortModel,
    totalRows,
    sortModelChangeHandler,
    sortingMode,
    autoHeight = true,
    columnVisibilityModel,
    rowSelectionModel,
    noRowsLabel,
    onTableScrollEnd,
    tableScrollData={}
  } = props;

  const gridContainerRef = useRef<HTMLDivElement>(null);

  const tblScrollRef = useRef(tableScrollData);

  useEffect(() => {
    tblScrollRef.current = tableScrollData;
  }, [tableScrollData]);

  useEffect(() => {
    if (!gridContainerRef.current) return;

    const observer = new MutationObserver(() => {
      const scroller =
        gridContainerRef.current?.querySelector(
          '.MuiDataGrid-virtualScroller'
        ) as HTMLElement | null;

      if (!scroller) return;

      const onScroll = () => {
        const { scrollTop, scrollHeight, clientHeight } = scroller;
        if (scrollTop + clientHeight >= scrollHeight - 2) {
          onTableScrollEnd?.(tblScrollRef.current )
        }
      };

      scroller.addEventListener('scroll', onScroll);
      observer.disconnect();
    });

    observer.observe(gridContainerRef.current, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);
  return (
    <div
      className={'data-tables-general'}
      data-testid='data-tables-test'
      ref={gridContainerRef}
      style={{height: '100%', overflow: 'auto'}}>
      <DataGrid
        autoHeight ={autoHeight}
        disableColumnMenu
        disableRowSelectionOnClick={true}
        hideFooterSelectedRowCount={true}
        rows={tblRows}
        loading={loadingTable}
        columns={tblColumns}
        pageSizeOptions={rowPerPages}
        onPaginationModelChange={onChangePageSize}
        rowCount={totalRows}
        getRowHeight={() => 'auto'}
        sortingMode={sortingMode}
        onSortModelChange={sortModelChangeHandler}
        columnVisibilityModel={columnVisibilityModel}
        slots={{
          pagination: () => customPaging
        }}
        localeText={
          noRowsLabel
            ? { noRowsLabel }
            : undefined
        }
        paginationMode={'server'}
        sx={{
          '& .MuiDataGrid-cell:focus, .MuiDataGrid-cell:focus-within': {
            outline: 'none',
            cursor: 'default'
          },
          '& .MuiDataGrid-row:hover': {
            backgroundColor: 'transparent'
          },
          '& .MuiDataGrid-columnHeader--moving': {
            backgroundColor: 'white'
          },
          '& .MuiDataGrid-columnHeader:focus,.MuiDataGrid-columnHeader:focus-within': {
            outline: 'none'
          },
          '& .MuiDataGrid-columnSeparator': {
            display: 'none'
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            fontSize: 12,
            fontWeight: 600,
            lineHeight: '160%',
            fontStyle: 'normal',
            color: '#212121'
          },
          '& .MuiDataGrid-row.Mui-hovered':{
            backgroundColor:'unset'
          }
        }}
        initialState={{
          sorting: {
            sortModel: defaultSortModel
          },
          pagination: {
            paginationModel: {
              pageSize: pageSize,
              page: 0
            }
          }
        }}
        rowSelectionModel={rowSelectionModel}
      />
    </div>
  );
};
